import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  children: ReactNode;
}

/**
 * 07-11 PRM-13: status is conveyed in text. Colour is a reinforcement, never
 * the carrier — each variant pairs its colour with a border weight.
 */
const VARIANTS: Record<BadgeVariant, string> = {
  default: 'border-line text-default',
  success: 'border-ready text-positive',
  warning: 'border-late text-caution',
  danger: 'border-blocked text-negative',
  info: 'border-new text-scheduled',
};

/** PRM-13 Badge — a short static status label. Default state only. */
export function Badge({ variant = 'default', className, children, ...props }: BadgeProps) {
  return (
    <span
      data-primitive="PRM-13"
      className={cn(
        'inline-block rounded-control border bg-sunken px-inline py-xs text-body-sm font-medium',
        VARIANTS[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
